import { Inject, Injectable, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private document: Document;
  private _currentTheme = signal<string>(this.getCurrentTheme());

  get currentTheme() {
    return this._currentTheme;
  }

  constructor(@Inject(DOCUMENT) document: Document) {
    this.document = document;
  }

  toggleTheme(): void {
    const body = this.document.body;
    if (body.classList.contains('dark')) {
      body.classList.remove('dark');
      body.classList.add('light');
      localStorage.setItem('theme', 'light');
    } else {
      body.classList.remove('light');
      body.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }
    this._currentTheme.set(this.getCurrentTheme());
  }

  initializeTheme(): void {
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      this.document.body.classList.add('dark');
    } else {
      this.document.body.classList.add('light');
      localStorage.setItem('theme', 'light');
    }
    this._currentTheme.set(this.getCurrentTheme());
  }

  getCurrentTheme(): string {
    const body = this.document?.body;
    if (body && body.classList.contains('dark')) {
      return 'dark';
    } else {
      return 'light';
    }
  }
}
